if (!customElements.get("video-action-button")) {
  customElements.define(
    "video-action-button",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const video = this.closest('.custom-video-wrapper')?.querySelector('video');
        const playIcon = this.querySelector('.play-icon');
        const pauseIcon = this.querySelector('.pause-icon');

        if (!video) return;

        this.addEventListener('click', () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          updateIcon();
        });

        video.addEventListener('playing', updateIcon);
        video.addEventListener('loadeddata', updateIcon);
        updateIcon();

        function updateIcon() {
          if (video.paused) {
            playIcon.style.display = 'inline';
            pauseIcon.style.display = 'none';
          } else {
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'inline';
          }
        }
      }
    }
  );
}
